{
  "404.message": "The page you were trying to reach could not be found. This could be because:",
  "404.message.reason1": "The page does not exist.",
  "404.message.reason2": "The page exists, but you do not have permission to view it.",
  "404.nav.dashboard": "Your Dashboard",
  "404.nav.home": "Site Homepage",
  "404.nav.title": "Go to",
  "404.search.title": "Site Search",
  "aboutpage.section.title": "Atlassian Confluence Cloud and Confluence Cloud Plugins",
  "accessibility.user.icon": "User icon",
  "action.add.comment": "Add Comment",
  "action.edit.comment": "Edit Comment",
  "action.reorder.pages.sentence": "Reorder pages",
  "action.space.addons": "Add-ons",
  "action.space.overview": "Overview",
  "actions.word": "Actions",
  "add.comment": "Add Comment",
  "add.comment.accesskey": "m",
  "add.shortcut": "Add shortcut",
  "add.word": "Add",
  "addlabels.teamlabels": "Categories",
  "adf.translation.error.in.render.description.prod": "Refresh the page and try again. If the problem persists, contact <a target=\"_blank\" href=\"{link}\">Atlassian Support</a>.",
  "adf.translation.error.in.render.description.staging": "An ADF error is preventing your content from being displayed. Discuss further in the <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> Slack channel.",
  "adf.translation.error.in.render.title.prod": "We couldn't display your content",
  "adf.translation.error.in.render.title.staging": "ADF error while displaying content",
  "adg3.feedback.placeholder": "Tell us about your experience using Confluence so that we can make it even better.",
  "adg3.give.feedback": "Give feedback",
  "adg3.onboarding.docs.link": "Learn more",
  "adg3.onboarding.next": "Next",
  "adg3.onboarding.prev": "Previous",
  "adg3.onboarding.sidebar.done": "Got it",
  "adg3.onboarding.skip": "Skip",
  "adg3.onboarding.start": "Get started",
  "adg3.onboarding.step1.content": "We've updated colours, icons, and fonts, so important things are easier to spot and your eyes don't need to work as hard.",
  "adg3.onboarding.step1.title": "Say hi to the new Confluence experience",
  "adg3.onboarding.step2.content": "The things you need most — search, create, and navigate — are all in the sidebar.",
  "adg3.onboarding.step2.title": "Simple sidebar navigation",
  "adg3.onboarding.step3.content": "Can't remember what you were working on? The search panel helps you out with a list of your recently viewed pages.",
  "adg3.onboarding.step3.title": "Pick up where you left off",
  "adg3.onboarding.step4.content": "Leave feedback via your profile to help make this even better. Not ready for the new experience yet? You can turn it off via your profile too.",
  "adg3.onboarding.step4.content.no.optout": "Your feedback plays a big part in improving the Confluence experience. Let us know what you think via your profile, to help make this even better.",
  "adg3.onboarding.step4.title": "Help us build the best Confluence",
  "adg3.onboarding.user.optin.content": "We've made changes based on feedback, but we're still improving. Drop us a note via Give feedback in the sidebar if you have more to share.",
  "adg3.onboarding.user.optin.done": "Got it",
  "adg3.onboarding.user.optin.title": "The new Confluence experience is now here for everyone",
  "adg3.send.feedback": "Send feedback",
  "adg3.sidebar.button.configure": "Configure sidebar",
  "adg3.sidebar.button.done": "Done",
  "adg3.sidebar.button.gotit": "Got it",
  "adg3.sidebar.link.disable": "Disable",
  "adg3.sidebar.link.enable": "Enable",
  "adg3.user.profile.other": "My Confluence",
  "admin.section.security.title": "Users & Security",
  "administration.name": "Administration",
  "all.updates.mainBanner": "There's not much happening... Yet",
  "all.updates.subBanner": "Keep up to date with everything that's happening in this site. New pages, files, edits and comments will all appear here.",
  "all.updates.subBanner2": "Time to create the next big thing.",
  "all.updates.title": "All updates",
  "anonymous.name": "Anonymous",
  "archived.spaces": "Archived Spaces",
  "atlassian.can.contact": "May we contact you to follow up on your feedback?",
  "atlassian.home.name": "Atlassian Home",
  "attach.files.no.permission": "You'll need to ask permission to insert files here.",
  "attach.files.tip.close": "Ok, got it!",
  "attach.files.tip.desc": "Drop files straight into your page to insert them directly.",
  "attach.files.tip.title": "Tip:",
  "attach.files.upload.files": "Upload files",
  "attach.files.upload.images": "Upload images",
  "audit.logging.category.user.management": "Users and groups",
  "aui.sidebar.collapse.tooltip": "Collapse sidebar ( [ )",
  "aui.sidebar.expand.tooltip": "Expand sidebar ( [ )",
  "author.name": "Author",
  "blog.personal.name": "Personal Blog",
  "blog.post": "Blog post",
  "blog.word": "Blog",
  "blogtree.failed.load.content": "Failed to load blog posts",
  "blueprint.navigation.items.create.new.template": "Create new template",
  "blueprint.navigation.items.create.new.template.disabled": "Only space admins can create templates",
  "blueprint.navigation.items.filter.for.templates": "Filter templates",
  "blueprint.navigation.items.page.templates.header": "Page Templates",
  "button.cancel": "Cancel",
  "cache.name.com.atlassian.confluence.pages.Draft": "Drafts",
  "calendar.share.button.keyboard.shortcut.desc": "Share",
  "calendar3.addcalendar": "Add Calendar",
  "calendar3.helptip.learn.more": "Learn More",
  "calendar3.spacecalendars.header": "Calendars",
  "calendar3.spacecalendars.onboarding.button.add.label": "Add Calendar",
  "calendar3.spacecalendars.onboarding.intro": "Add a calendar to track your team's leave, plan Jira projects, and get everyone aligned around important dates.",
  "calendar3.spacecalendars.onboarding.title": "The source of truth for your team or project",
  "cancel.name": "Cancel",
  "captcha.response.failed": "The typed word did not match the text in the picture.",
  "categories.name": "Categories",
  "changeboarding.dnd.pagetree.spacesettings.banner": "Space organisation just got easier, with the ability to drag-and-drop to reorder pages in your sidebar",
  "changeboarding.dnd.pagetree.spotlight.message": "Drag and drop to move pages and organise your space.",
  "changes-diff.heading.key": "Key",
  "changes-diff.these.lines.were.added": "This line was added.",
  "changes-diff.these.lines.were.removed": "This line was removed.",
  "changes-diff.this.content.was.modified": "Formatting was changed.",
  "clear.name": "Clear",
  "clipboardaccess.browser.not.supported": "Your browser does not support pasting images from the clipboard.",
  "clipboardaccess.ok": "OK",
  "close.draft.name": "Close draft",
  "close.name": "Close",
  "collab.edit.user.limit.msg.body": "<p>This page is so popular, you've reached the maximum number of simultaneous editors.</p><p>Try again when it's not so busy.</p>",
  "collab.edit.user.limit.msg.title": "You can't edit this page right now",
  "collab.status.connected": "Ready to go",
  "collab.status.connecting": "Connecting...",
  "collab.status.error": "Can't save changes",
  "collab.status.tooltip.error": "Copy your work, refresh the page, and we'll try to reconnect.",
  "collab.status.tooltip.failure": "Your internet is playing up. Please check your connection and refresh.",
  "collab.status.tooltip.success": "We're autosaving your changes, so you never need to press save.",
  "collapse.name": "Collapse",
  "colourname.property.style.bordercolour": "Borders and Dividers",
  "colourname.property.style.breadcrumbstextcolour": "Top Bar Text",
  "colourname.property.style.headerbuttonbasebgcolour": "Header Button Background",
  "colourname.property.style.headerbuttontextcolour": "Header Button Text",
  "colourname.property.style.headingtextcolour": "Heading Text",
  "colourname.property.style.linkcolour": "Links",
  "colourname.property.style.menuitemselectedbgcolour": "Menu Item Selected Background",
  "colourname.property.style.menuitemselectedtextcolour": "Menu Item Selected Text",
  "colourname.property.style.menuitemtextcolour": "Page Menu Item Text",
  "colourname.property.style.menuselectedbgcolour": "Page Menu Selected Background",
  "colourname.property.style.navbgcolour": "Tab Navigation Background",
  "colourname.property.style.navselectedbgcolour": "Tab Navigation Background Highlight",
  "colourname.property.style.navselectedtextcolour": "Tab Navigation Text Highlight",
  "colourname.property.style.navtextcolour": "Tab Navigation Text",
  "colourname.property.style.searchfieldbgcolour": "Search Field Background",
  "colourname.property.style.searchfieldtextcolour": "Search Field Text",
  "colourname.property.style.spacenamecolour": "Space Name Text",
  "colourname.property.style.topbarcolour": "Top Bar",
  "colourname.property.style.topbarmenuitemtextcolour": "Top Bar Menu Item Text",
  "colourname.property.style.topbarmenuselectedbgcolour": "Top Bar Menu Selected Background",
  "colourname.property.style.topbarmenuselectedtextcolour": "Top Bar Menu Selected Text",
  "com.atlassian.confluence.contributors.contributors.label": "Contributors",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "View File",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "Got it, thanks!",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "Edit Page",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "Roadmap Planner",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "Page Tree",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "Filter",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "Hint: type \"g\" and then \"r\" anywhere to quickly open this menu",
  "com.atlassian.confluence.plugins.recently.viewed.title": "Recently viewed pages",
  "com.atlassian.confluence.plugins.status-macro.status.label": "Status",
  "com.atlassian.mywork.header.notifications": "Notifications",
  "comment.display.name.anonymous": "Anonymous",
  "comment.edit": "Edit",
  "comment.edited": "Edited",
  "comment.edited.by": "Edited by {username} {at}",
  "comment.name.tooltip": "Add a Comment",
  "comment.notification.enable": "Watch this page",
  "comment.permalink": "Permalink",
  "comment.plural": "{0} Comments",
  "comment.remove": "Delete",
  "comment.reply": "Reply",
  "comment.singular": "1 Comment",
  "compare.selected": "Compare selected versions",
  "configuration.name": "Configuration",
  "confluence.extra.attachments.attachments.label": "Attachments",
  "confluence.extra.jira.jira.label": "Jira",
  "confluence.extra.masterdetail.detailssummary.label": "Page Properties Report",
  "confluence.home": "Confluence Home",
  "confluence.macros.advanced.children.label": "Children Display",
  "confluence.macros.advanced.contentbylabel.label": "Content by Label",
  "confluence.macros.advanced.recently-updated.label": "Recently Updated",
  "confluence.mobile.nav.switch.to.mobile.action": "Switch to Confluence mobile",
  "confluence.mobile.nav.switch.to.mobile.text": "You are viewing the desktop version on a mobile device.",
  "confluence.mobile.refresh": "Refresh",
  "confluence.request.access.pagerestricted.inherited.description": "This is because it's inheriting restrictions from a parent page. A space admin or the person who shared this page may be able to give you access.",
  "confluence.request.access.pagerestricted.request.access.button": "Request access",
  "confluence.request.access.pagerestricted.requestaccess.description": "Hit the request access button and we'll find someone who can give you access.",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "You don't have permission to edit this page",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "You don't have permission to view this page",
  "confluence.user.profile.department": "Department",
  "confluence.user.profile.location": "Location",
  "confluence.user.profile.position": "Position",
  "connect.addon.wait.or": "Wait or",
  "content.empty": "Comment text is empty. Cannot create empty comments.",
  "content.kind.decisions": "Decision",
  "content.kind.file-list": "File list",
  "content.kind.jirareport": "Jira report",
  "content.kind.kb-how-to-article": "How to article",
  "content.kind.kb-troubleshooting-article": "Troubleshooting article",
  "content.kind.meeting-notes": "Meeting notes",
  "content.kind.product-requirements": "Product requirements",
  "content.kind.retrospective": "Retrospective",
  "content.kind.shared-links": "Shared links",
  "content.kind.task-report": "Task report",
  "content.type.attachment": "Attachments",
  "content.type.blogpost": "Blogs",
  "content.type.page": "Pages",
  "cq.header.title": "Questions",
  "create.blog.post.event.description": "Create Blog Post",
  "create.drawer.header": "Create",
  "create.drawer.page.selector.all.pages.in.space": "All pages in this space",
  "create.drawer.page.selector.location.header": "Location",
  "create.drawer.page.selector.no.page.found": "No pages found",
  "create.drawer.page.selector.no.parent.page": "No parent page",
  "create.drawer.page.selector.pages.loading": "Loading pages",
  "create.drawer.page.selector.parent.page": "Parent page",
  "create.drawer.page.selector.parent.page.tooltip.help": "Blogs, Calendars, and Questions will not appear under a parent page",
  "create.drawer.page.selector.recent.pages": "Recent pages",
  "create.drawer.page.selector.select.parent.page": "Select a parent page",
  "create.drawer.space.selector.header": "Space",
  "create.drawer.space.selector.location.header": "Location",
  "create.drawer.space.selector.no.space.found": "No spaces found",
  "create.drawer.space.selector.recent.spaces": "Recent spaces",
  "create.drawer.space.selector.search.spaces": "All spaces",
  "create.drawer.space.selector.select.a.space": "Select a space",
  "create.drawer.space.selector.spaces.loading": "Loading spaces",
  "create.drawer.space.selector.starred.spaces": "Starred spaces",
  "create.drawer.template.failed.to.load.atlassian.support": "Atlassian Support.",
  "create.drawer.template.failed.to.load.content": "Refresh the page and try again. If the problem persists, contact",
  "create.drawer.template.failed.to.load.title": "Template failed to load",
  "create.name": "Create",
  "css.file": "CSS File",
  "current.space": "Current Space",
  "default.space.homepage.title": "{0} Home",
  "delete.name": "Delete",
  "desc.colourscheme": "The following colours can be customised for this colour scheme.",
  "description.name": "Description",
  "discard.name": "Discard",
  "discover.applications": "Discover applications",
  "draft": "Draft",
  "draft.no.content": "This draft has no content.",
  "edit.comment": "Edit Comment",
  "edit.labels": "Add labels",
  "editor-help.fabric.help.center.feedback.item": "Feedback",
  "editor.adf.parsing.error.details": "Error details:",
  "editor.adf.parsing.error.message.prod": "Refresh the page and try again. If the problem persists, contact <a target=\"_blank\" href=\"{link}\">Atlassian Support</a>.",
  "editor.adf.parsing.error.message.staging": "Our team has been notified, but you can also discuss this in the <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> channel in Slack.",
  "editor.adf.parsing.error.title.prod": "We couldn't load the editor.",
  "editor.adf.parsing.error.title.staging": "We had a problem converting this document to ADF",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} Attachments",
  "editor.attachments.singular": "{0} Attachment",
  "editor.attachments.zero": "Attachments",
  "editor.autocomplete.file.header.text": "File suggestions",
  "editor.autocomplete.links.create.link": "Insert link to create page",
  "editor.autocomplete.links.dialog.search": "Search for &lsquo;{0}&rsquo;",
  "editor.autocomplete.links.dialog.search.no.text": "Search",
  "editor.autocomplete.links.header.text": "Link suggestions",
  "editor.autocomplete.links.web.link": "Insert web link",
  "editor.autocomplete.macros.dialog.browse": "Open macro browser",
  "editor.autocomplete.macros.error.load.header": "Failed to get macro details",
  "editor.autocomplete.macros.error.load.retrylink": "Try again",
  "editor.autocomplete.macros.header.text": "Macro suggestions",
  "editor.autocomplete.media.files.dialog.browse": "Open file library",
  "editor.autocomplete.media.header.text": "Media suggestions",
  "editor.autocomplete.media.images.dialog.browse": "Open image browser",
  "editor.autocomplete.media.macros.dialog.browse": "Insert other media",
  "editor.autoformat.sampletext.firstcell": "first cell",
  "editor.autoformat.sampletext.heading": "heading",
  "editor.buttons.disable.by.empty.title.tooltip": "Your page needs a title before it can be published.",
  "editor.buttons.disable.by.not.saving.tooltip": "Still working...",
  "editor.buttons.disable.by.saving.tooltip": "We're still saving your page.",
  "editor.cancel.discard.changes.confirmation": "Discard changes",
  "editor.cancel.discard.changes.message": "All content entered will be discarded. Please confirm.",
  "editor.cancel.discard.changes.title": "Confirm discard of all changes",
  "editor.cant.publish.changes": "Can't publish changes",
  "editor.change.comment": "What did you change?",
  "editor.close.publish.tooltip": "Save changes without publishing",
  "editor.close.update.tooltip": "Save changes without updating",
  "editor.collab.user.limit.body": "This page is so popular, you've reached the maximum number of simultaneous editors. Try again when it's not so busy.",
  "editor.collab.user.limit.title": "You can't edit this page right now",
  "editor.collaborative-editing.load.error": "It's taking longer than usual to load this page. Give it a few moments, then try reloading. If it still doesn't load, speak to your Confluence admin.",
  "editor.collaborative-editing.refresh-editor.error": "Something went wrong while loading the editor, please try again.",
  "editor.collaborative.mode.disabled": "Collaborative editing is offline right now. Copy your work, then refresh the page to continue editing.",
  "editor.collaborative.mode.enabled": "Collaborative editing was switched off, but it's back in business. Copy your changes and refresh the page to keep editing.",
  "editor.content.appearance.toggle.fixed.width": "Make page full-width",
  "editor.content.appearance.toggle.full.width": "Make page fixed-width",
  "editor.content.placeholder.11": "Did you know you can add all kinds of cool things to this page, like a table of contents, date, or roadmap? Type / to open a list.",
  "editor.content.placeholder.ai": "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know).",
  "editor.content.placeholder.bpqa": "Type / to see a list of elements, @ to mention someone, or select from below:",
  "editor.content.placeholder.bpqa.ai": "Type /ai for Atlassian intelligence, / for elements, @ to mention someone, or select from below:",
  "editor.content.placeholder.easy.mentions": "Type / for all elements or @ to mention someone.",
  "editor.content.placeholder.slash": "Type / to insert any element",
  "editor.content.placeholder.slash.bracket": "Any element can be quickly inserted by typing /",
  "editor.content.reconciliation.error.details": "Error details:",
  "editor.content.reconciliation.error.fatal.prod": "Our team has been notified. Wait a few minutes and try again. If the problem persists, contact Atlassian Support.",
  "editor.content.reconciliation.error.fatal.staging": "Our team has been notified, but you can also discuss this in the #cc-content-experience channel in Slack.",
  "editor.content.reconciliation.error.retrying": "Retrying in {0} ...",
  "editor.content.reconciliation.error.title": "This page has failed to load",
  "editor.content.reconciliation.networkerror.fatal.prod": "Refreshing the page should fix this issue. If the problem persists, contact <a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">Atlassian Support</a> or your space admin.",
  "editor.content.reconciliation.networkerror.title": "We’re having trouble loading your content",
  "editor.discard-on-close.tooltip": "Discard empty draft",
  "editor.discard-to-published.button.label": "Discard",
  "editor.discard-to-published.button.tooltip": "Revert to last published version of the page",
  "editor.discard-to-published.dialog.title": "Discard unpublished changes?",
  "editor.discard-to-published.dialog.warning": "This will restore the editor to the last published version of this page. If anyone else has unpublished changes on the page, you'll be discarding those changes too.",
  "editor.discard-to-published.error.message": "We can't get the last published version of the page at the moment. Give it a few moments then try discarding the draft again.",
  "editor.discard-to-published.error.title": "Can't revert to last published version",
  "editor.discard-to-published.success.message": "Successfully reverted to the last published version",
  "editor.draft.can.be.migrated": "Collaborative editing is here! So that you can keep working on this page, we need to migrate the content to a new draft for you.<br><a href={0}>Migrate now</a>",
  "editor.dynamic-macro.preview.limit.desc": "Preview of dynamic macro on draft is only fully supported when shared drafts enabled.",
  "editor.ellipsis.blog.delete": "Delete unpublished blog post",
  "editor.ellipsis.import-document": "Open template and import doc",
  "editor.ellipsis.open.template.browser": "Open template browser",
  "editor.ellipsis.open.templates.and.import": "Templates & import doc",
  "editor.ellipsis.page.delete": "Delete unpublished page",
  "editor.ellipsis.remove": "Revert to last published version",
  "editor.ellipsis.resolved.comments": "Resolved comments",
  "editor.ellipsis.view-changes": "View changes",
  "editor.error.delayed.publishing": "We'll continue trying to publish. If it’s taking too long, refresh the page and click <strong>Publish</strong>.",
  "editor.error.delayed.publishing.title": "We’re having trouble publishing your content.",
  "editor.excerpt.include.macro.error": "Error loading excerpt from \"{0}\".",
  "editor.excerpt.panel.title.loading": "Loading...",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "Untitled Blog post",
  "editor.fabric.share.invite.to.edit.empty.page.title": "Untitled Page",
  "editor.fabric.share.invite.to.edit.form.title": "Invite To Edit",
  "editor.files.may.be.uploading": "Some files may still be uploading. Wait a minute, then try again. If it doesn't work, refresh the page, and re-upload any files that appear broken before publishing.",
  "editor.generic.refresh": "Something went wrong with the editor. Copy your unsaved changes and refresh the page to keep editing.",
  "editor.go.back": "Go back",
  "editor.heartbeat.unauthorised.warning.generic.body": "This content has been moved, restricted, or deleted. We recommend you copy anything you need and close the editor.",
  "editor.heartbeat.unauthorised.warning.generic.title": "No access to this page",
  "editor.heartbeat.unauthorised.warning.page-move.body": "You can't publish due to a page move or change in restrictions. We recommend you copy anything you need and close the editor.",
  "editor.heartbeat.unauthorised.warning.page-move.title": "Page permissions have changed",
  "editor.help.how.to.use.blueprint": "How to use {blueprintType}",
  "editor.help.templates": "Use page templates",
  "editor.help.updates": "Editing updates",
  "editor.help.updates.1.description": "The first phase of editing improvements have landed on blog posts. Responsive content, better image handling, and a more streamlined interface. Create a new blog post to check it out.",
  "editor.help.updates.1.title": "Blog posts",
  "editor.help.updates.2.description": "The new editing experience has now rolled out to meeting notes. Latest updates include advanced table functionality, which is toggled by clicking on a table, and improvements to speed and reliability.",
  "editor.help.updates.2.title": "Meeting Notes",
  "editor.hints.close": "Close hints",
  "editor.hints.next": "Next hint",
  "editor.labels": "{0}",
  "editor.labels.desc": "Edit page labels",
  "editor.labels.plural": "{0} Labels",
  "editor.labels.singular": "{0} Label",
  "editor.labels.zero": "Labels",
  "editor.learn.more": "Learn more",
  "editor.location.desc": "Add location",
  "editor.minor.edit": "Notify watchers",
  "editor.offline.before.save.error": "Unable to communicate with server. Saving is not possible at the moment.",
  "editor.offline.preview.error": "Can't reach the server. Check you're connected to the internet and Confluence is up and running.",
  "editor.offline.save.error": "Unable to communicate with server. Saving is not possible at the moment.",
  "editor.offline.save.error.generic": "There was an error processing the request.",
  "editor.offline.save.noauthorized": "Your session has expired. You'll need to log in again or switch to another account to keep working. \n <div><a href=\"/login?application=confluence\">Log in or switch to another account</a></div>",
  "editor.offline.save.noauthorized.title": "Can't connect to the server",
  "editor.offline.save.page.exist.content": "A page with the title '{0}' already exists in this space. Enter a different title for your page.",
  "editor.onboarding.draft.placeholder": "Type / for a list of useful elements you can add to the page, like a table of contents or roadmap.<br/>Or if your mind’s gone as blank as this page, start with one of the templates on the right →",
  "editor.onboarding.spotlight.body": "Find out what's changing and why.",
  "editor.onboarding.spotlight.finish": "Got it",
  "editor.onboarding.spotlight.title": "We're updating your templates, one by one",
  "editor.onboarding.step1.content": "We're working on delivering features you've been asking for, starting with improved readability, smarter formatting tools, and a more modern look. <br /><a href=\"{linkCAC}\" target=\"_blank\">Learn more about what's changing</a>",
  "editor.onboarding.step1.title": "Friendlier blog posts",
  "editor.onboarding.step2.content": "Your most used features are in the toolbar, while more advanced tools are under the plus sign. You also have a bunch of new emojis to brighten your day! <br/><a href=\"{linkCAC}\" target=\"_blank\">Learn more about what's changing</a>",
  "editor.onboarding.step2.title": "Looking for something?",
  "editor.onboarding.step3.content": "This is a work in progress, and we need your help to make it awesome. Send us your feedback and follow the <a href=\"{linkCAC}\" target=\"_blank\">Confluence page</a> to stay updated about changes. <br/><a href=\"{linkCAC}\" target=\"_blank\">Learn more about what's changing</a>",
  "editor.onboarding.step3.title": "Let's create something great together",
  "editor.page.can.not.be.accessed.message": "Your session may have expired. You'll need to log in again or switch to another account to keep working. \n <div><a href=\"/login?application=confluence\">Log in or switch to another account</a></div>",
  "editor.page.can.not.be.accessed.title": "This content cannot be accessed.",
  "editor.page.conflict.message": "Refresh the page to try to re-establish the connection.",
  "editor.page.conflict.title": "Can't sync with the server.",
  "editor.page.is.too.big": "This page is too big to save. You could split it into multiple pages, then use the <a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">include page macro</a> to display the content.",
  "editor.page.is.trashed.message": "Copy your content, then add it to a new page or <div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">restore this page from the trash</a> and try again.</div>",
  "editor.page.is.trashed.title": "This content has been deleted",
  "editor.page.legacy.draft.deprecated": "Collaborative editing is here! That means we need a little help from you to restart your editing session. All you need to do is copy the content, edit this page again, then paste it in and save.",
  "editor.page.moved.message.body": "It's ok, though - you can still publish your changes when you're ready. <br /><br /> New Location: {0}",
  "editor.page.moved.message.title": "{0} moved this page",
  "editor.page.moved.message.unknown.mover": "Another user",
  "editor.placeholder.broken.image": "Broken image",
  "editor.placeholder.broken.link": "Broken link",
  "editor.placeholder.broken.macro": "Broken macro",
  "editor.placeholder.error": "Error",
  "editor.preview.error": "There was an error loading preview. Please try again later.",
  "editor.publish.blog": "Publish",
  "editor.publish.blog.desc": "Publish your blog post",
  "editor.publish.external.share.label": "Externally shared",
  "editor.publish.hotkey.description": "To publish this content, select {keyCombination} on your keyboard.",
  "editor.publish.with.comment": "Publish with version comment...",
  "editor.publish.without.notify": "Publish without notifying watchers",
  "editor.quit-dialog.button.delete.blog.exit": "Delete blog post",
  "editor.quit-dialog.button.delete.page.exit": "Delete page",
  "editor.quit-dialog.button.discard.changes.by.many": "Discard <strong>everyone's</strong> changes",
  "editor.quit-dialog.button.discard.changes.by.one": "Discard <strong>all</strong> changes",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "Discard all unpublished changes",
  "editor.quit-dialog.button.discard.limited.tooltip": "Collaborative editing is disabled. You can discard changes when it's enabled again.",
  "editor.quit-dialog.button.revert.blog.exit": "Revert blog post",
  "editor.quit-dialog.button.revert.page.exit": "Revert page",
  "editor.quit-dialog.button.save.exit": "Keep draft",
  "editor.quit-dialog.cancel.changes.by.many": "<p>There are changes made by you and other people that haven't been published yet.</p>\n<p>If you discard changes, you'll delete changes made by the following people, and revert to the last published version of this page. They won't be able to recover their work if you do this.</p>\n\n<p>These people have made changes:</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p>You've made changes that haven't been published yet.</p><p>If you discard changes, your unpublished changes will be deleted. You can't undo this action.</p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "This will permanently delete this blog post, which you and these other people have worked on.",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "Once you delete an unpublished blog post, it's gone for good.",
  "editor.quit-dialog.delete.page.changes.by.many": "This will permanently delete this page, which you and these other people have worked on.",
  "editor.quit-dialog.delete.page.changes.by.one": "If you delete an unpublished page, it's gone for good.",
  "editor.quit-dialog.last.edited": "Last edited",
  "editor.quit-dialog.link.hide.diff": "Hide changes",
  "editor.quit-dialog.link.show.diff": "Show changes",
  "editor.quit-dialog.publish.changes": "You'll also be publishing changes made by these people:",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "This will permanently delete all the changes you made since this blog post was last published",
  "editor.quit-dialog.revert.changes.by.many": "This will permanently delete all the changes that the following people have made, since this page was last published.",
  "editor.quit-dialog.revert.page.changes.by.one": "This will permanently delete all the changes you made since this page was last published.",
  "editor.quit-dialog.title.blogpost.delete": "Delete unpublished blog post?",
  "editor.quit-dialog.title.discard": "Revert to last published version?",
  "editor.quit-dialog.title.exit": "Close the editor",
  "editor.quit-dialog.title.page.delete": "Delete unpublished page?",
  "editor.quit-dialog.title.publish": "Publish the page?",
  "editor.restrictions.desc": "Edit page restrictions",
  "editor.return.to.edit": "Return to edit mode",
  "editor.satisfaction.survey.description": "How was your editing experience?",
  "editor.satisfaction.survey.final.description": "Your feedback has been submitted",
  "editor.satisfaction.survey.final.title": "Thank you",
  "editor.satisfaction.survey.question.bad": "We're sorry to hear that. What went wrong? (optional)",
  "editor.satisfaction.survey.question.good": "Thanks! What did you like about it? What could be improved? (optional)",
  "editor.satisfaction.survey.title": "Your page has been published",
  "editor.save.draft.desc": "Save your draft",
  "editor.save.page.desc": "Save your page",
  "editor.shared.draft.done.desc": "Save draft; if empty, discard it",
  "editor.shared.draft.publish.desc": "Publish changes",
  "editor.shared.draft.update.desc": "Update the published page",
  "editor.shortcuts": "Editing keyboard shortcuts",
  "editor.synchrony.publish-page.message": "{0} published this page.",
  "editor.template.changing.variable.dialog.title": "Edit template variable",
  "editor.template.variable.input.creation.error.action": "Visit Atlassian Support",
  "editor.template.variable.input.creation.error.description": "Refresh the page and try again. If this keeps happening, let us know using the link below.",
  "editor.template.variable.input.creation.error.title": "Something went wrong",
  "editor.template.variable.list.field.placeholder": "option1, option2, option 3",
  "editor.template.variable.name.field": "Variable name",
  "editor.title.is.empty": "Add a page title before hitting publish.",
  "editor.title.is.empty.title": "This page needs a name",
  "editor.title.placeholder": "Give this page a title",
  "editor.title.too.long": "Title cannot be longer than 255 characters.",
  "editor.unavailable.generic.body": "Editing is unavailable right now. Try again in a few minutes.",
  "editor.unavailable.title": "Unable to edit",
  "editor.unpublished.changes.lozenge.label": "Unpublished",
  "editor.unpublished.changes.lozenge.tooltip": "This page has unpublished changes",
  "editor.waiting.to.publish.changes": "There may be a file upload still in progress.",
  "editor.waiting.to.publish.changes.title": "Bear with us, this is taking a moment.",
  "email.text.added.by": "Added by",
  "error.connection.lost.body": "We'll just wait here while you reconnect.",
  "error.connection.lost.title": "Looks like you've lost your connection.",
  "error.connection.recovered.action": "Reload the content",
  "error.connection.recovered.title": "Connected again",
  "error.notfound.title": "Aww shoot, we can't find that page.",
  "error.recovery.body": "Your changes are safe. Please refresh the page and try again.",
  "error.recovery.title": "Something went wrong while loading the editor",
  "error.server-error.body": "Try again later.",
  "error.server-error.title": "Something's gone wrong.",
  "error.session.expired.body": "We'll hold on tighter next time, promise.",
  "error.session.expired.title": "Looks like we lost your session.",
  "excel.file": "Microsoft Excel Spreadsheet",
  "excel.macro.file": "Microsoft Excel Macro-Enabled Spreadsheet",
  "excel.template.file": "Microsoft Excel Template",
  "excel97.file": "Microsoft Excel Sheet",
  "excel97.template.file": "Microsoft Excel 97 Template",
  "existing.blogpost.placeholder": "Blog post title",
  "expand-macro.default-title": "Click here to expand...",
  "expand.name": "Expand",
  "fabric.editor.announcement.datednotice.main": "On {0} you’ll be upgraded to our new editing experience.",
  "fabric.editor.announcement.dismiss": "Dismiss",
  "fabric.editor.announcement.greeting": "Hi {0}.",
  "fabric.editor.announcement.initialnotice.main": "In a few weeks the way you create content on Confluence will change.",
  "fabric.editor.announcement.link.action": "Find out what’s changing, and what new features you’ll receive.",
  "fabric.editor.announcement.rollbacknotice.action": "Please read the announcement on how to return existing pages to the old experience.",
  "fabric.editor.announcement.rollbacknotice.main": "Recently, your pages were accidentally updated to the new editing experience. We've now rolled this back.",
  "fabric.editor.announcement.tryit.action": "Try it on a new page.",
  "fabric.editor.announcement.tryitnotice.main": "The new editing experience gives you better looking pages, and new features like live macros.",
  "fabric.editor.changeboarding.banner.action": "See what new things you can do.",
  "fabric.editor.changeboarding.banner.dismiss": "Dismiss",
  "fabric.editor.changeboarding.banner.main": "Hi {0}, we're making some changes to help you create better looking, more readable content.",
  "fabric.editor.page.removed.description": "Please refresh now.",
  "fabric.editor.page.removed.title": "This page was recently archived or deleted",
  "fabric.editor.permission.removed.description": "The permissions for this page were changed. Contact an admin for help.",
  "fabric.editor.permission.removed.title": "We can't show this page",
  "fabric.full.width.help.center.dialog.title": "New! Width control",
  "fabric.full.width.help.center.pageElement.details": "<p>Expands <strong>all page elements</strong> horizontally, which results in less white space. The toggle also returns the page content to fixed-width.</p>",
  "fabric.full.width.help.center.pageElement.title": "Full-width page toggle",
  "fabric.full.width.help.center.tableElement.details": "<p>Control the width of <strong>each column, table,</strong> and most <strong>macros</strong> using wide or full-width options; you can also target certain elements to remain at fixed-width.</p>",
  "fabric.full.width.help.center.tableElement.title": "Individual element toggle",
  "fabric.help.center.columns.details": "<p>Add a <strong>column</strong> to your page, then use the <strong>floating menu</strong> to switch between 2 or 3 column configurations.</p>",
  "fabric.help.center.columns.title": "Columns",
  "fabric.help.center.dialog.title": "Learn the basics",
  "fabric.help.center.imageDisplay.details": "<p>Select an image, then drag the <strong>handles</strong> to resize it, or use the <strong>floating menu</strong> to change its alignment.</p>",
  "fabric.help.center.imageDisplay.title": "Image display",
  "fabric.help.center.layouts.details": "<p>Use <kbd>←</kbd> <kbd>→</kbd> to change how columns, tables, and macros are laid out.</p><p>Choose between a <strong>fixed-width</strong> that stays the same across screens, <strong>full-width</strong> which expands to fill the space, or an in-between <strong>wide</strong> setting.</p>",
  "fabric.help.center.layouts.title": "Layouts",
  "fabric.help.center.menuitem.title": "Tutorial",
  "fabric.help.center.slashCommands.details": "<p>Type <kbd>/</kbd> to open a menu and insert content like <strong>tables</strong>, <strong>macros</strong>, and <strong>dates</strong> to your page as you go.</p>",
  "fabric.help.center.slashCommands.title": "Slash commands",
  "fabric.help.center.spotlight.body": "Come back here any time to revisit the tutorial.",
  "fabric.help.center.spotlight.header": "Need a refresher?",
  "fabric.help.center.tableManipulation.details": "<p>Edit or format tables from the <strong>table borders</strong>, <strong>dropdown</strong>, and <strong>floating menu</strong>.</p>",
  "fabric.help.center.tableManipulation.title": "Table manipulation",
  "fabric.help.center.templates.details": "<p>Find a template that meets your needs. Reopen the panel from the More actions (•••) menu when it's closed.</p>",
  "fabric.help.center.templates.title": "Templates",
  "fabric.help.center.title": "Learn the basics",
  "fabric.insert.external.image": "Insert image from the web",
  "fabric.template.can.not.parse.content": "We can’t open this template because it contains broken or unsupported elements.",
  "fabric.template.can.not.save.error.title": "Can't save changes",
  "fabric.template.can.not.save.error.title.duplicate": " There’s already a template called <strong>{0}</strong>. Give your template a different title to save it.",
  "fabric.template.found.invalid.node": "Multiple template variables which have the same name \"{variableNames}\" but different parameters.",
  "favourite.spaces": "My Spaces",
  "feedback.flag.thanks.description": "Your feedback helps us build better experiences.",
  "feedback.flag.thanks.title": "Thanks!",
  "filter.name": "Filter",
  "gif.file": "GIF File",
  "global.spaces": "Site Spaces",
  "globaladminbilling.label": "Billing",
  "header.or.footer.unsupported.macros.list": "The following macros are not currently supported in the {0}:",
  "header.or.footer.unsupported.macros.title": "Unsupported macros",
  "heading.comment": "Changed By",
  "heading.createpage": "Create Page",
  "heading.createpage.sentence": "Create page",
  "heading.operations": "Operations",
  "heading.version.date": "Date",
  "heading.version.number": "Version",
  "help.name": "Help",
  "help.us.improve": "Help us improve",
  "hipchat.presence.status.available": "Available",
  "hipchat.presence.status.away": "Away",
  "hipchat.presence.status.dnd": "Do not disturb",
  "hipchat.presence.status.offline": "Offline",
  "html.file": "HTML File",
  "icon.tooltip.remove": "Remove",
  "icon.tooltip.undo": "Undo",
  "image.browser.imageurl.label": "Image URL",
  "image.height": "Height",
  "image.properties.dialog.cancel": "Cancel",
  "image.properties.dialog.heading": "Image Properties",
  "image.properties.trigger": "Properties",
  "image.properties.trigger.tooltip": "Set additional image properties",
  "inline.comment.sidebar.navigate.next.description": "Next Inline Comment",
  "inline.comment.sidebar.navigate.previous.description": "Previous Inline Comment",
  "inline.comments.GROW-1507.dialog.close.label": "Close",
  "inline.comments.GROW-1507.dialog.content": "Do you know about inline comments?<br>You can use them for reviewing, adding them on a specific part of the document.",
  "inline.comments.GROW-1507.dialog.header": "Inline comments",
  "inline.comments.GROW-1507.dialog.ok.label": "OK, got it",
  "inline.comments.GROW-1507.dialog.showme.label": "Show me",
  "inline.comments.GROW-1507.dialog.title": "COMMENT TIP",
  "inline.comments.batch.email.view": "View comment",
  "inline.comments.create.placeholder": "write a comment…",
  "inline.comments.create.reply.placeholder": "Reply",
  "inline.comments.date.friendly.about.one.hour.ago": "1 hour ago",
  "inline.comments.date.friendly.about.x.days.ago": "{0} days ago",
  "inline.comments.date.friendly.about.x.hours.ago": "{0} hours ago",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "just now",
  "inline.comments.date.friendly.one.min.ago": "1 minute ago",
  "inline.comments.date.friendly.x.mins.ago": "{0} {0, plural, one {minute} other {minutes}} ago",
  "inline.comments.date.friendly.yesterday": "yesterday",
  "inline.comments.delete.confirmation.message": "Are you sure you want to delete the comment?",
  "inline.comments.delete.permission": "You don't have permission to delete this comment.",
  "inline.comments.delete.reply.confirmation.message": "Are you sure you want to delete this reply?",
  "inline.comments.delete.with.reply": "You can't delete inline comment threads with replies.",
  "inline.comments.delete.with.reply.need.reload": "You can't delete this comment because there are new replies on this thread. Please reload to view them.",
  "inline.comments.edit.permission": "You don't have permission to edit this comment.",
  "inline.comments.editor.lost": "Your comment will be lost.",
  "inline.comments.editor.timeout": "The editor didn't load properly. Please {0}reload the page{1} to try again.",
  "inline.comments.expand.replies": "{0} more replies",
  "inline.comments.fabric.editor.error.cannot.be.empty": "Your comment is empty. Add your feedback, and click Save.",
  "inline.comments.fabric.editor.error.captcha.check.failed": "Captcha check failed",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "Captcha check succeeded",
  "inline.comments.fabric.editor.error.create.not.permitted": "Your permission settings don’t allow you to create comments. Check with your administrator if you need this ability.",
  "inline.comments.fabric.editor.error.delete.not.permitted": "Your permission settings don’t allow you to delete comments. Check with your administrator if you need this ability.",
  "inline.comments.fabric.editor.error.edit.not.permitted": "Your permission settings don’t allow you to edit comments. Check with your administrator if you need this ability.",
  "inline.comments.fabric.editor.error.invalid.selection": "Unable to create comment. Create your highlight on more unique text, to make the selection distinct, so that your comment maps to the right content.",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "Your permission settings don’t allow you to resolve comments. Check with your administrator if you need this ability.",
  "inline.comments.fabric.editor.error.unexpected": "Something went wrong when saving this comment. Close the comment or refresh the page, and try adding your comment again.",
  "inline.comments.fabric.editor.error.view.not.permitted": "Your permission settings don’t allow you to view the comment. Check with your administrator if you need this ability.",
  "inline.comments.fabric.inline.button.cancel": "Cancel",
  "inline.comments.fabric.inline.button.save": "Save",
  "inline.comments.fabric.sidebar.loading.error": "An error occured, please close the comment window and try again",
  "inline.comments.likes.error": "Likes cannot be updated.",
  "inline.comments.likes.like": "Like",
  "inline.comments.likes.unlike": "Unlike",
  "inline.comments.navigation.index.of": "{0} of {1}",
  "inline.comments.notification.email.reopened": "Reopened",
  "inline.comments.notification.email.resolved": "Resolved",
  "inline.comments.notification.email.view": "View comment",
  "inline.comments.resolve.permission": "You don't have permission to resolve this comment.",
  "inline.comments.resolved.dangling.message": "Resolved because the text was deleted by {0} {1}",
  "inline.comments.resolved.dialog.empty": "There are no resolved comments on this page.",
  "inline.comments.resolved.dialog.message": "This comment isn't gone forever! You can see resolved comments at any time.",
  "inline.comments.resolved.dialog.show.me": "Show me",
  "inline.comments.resolved.discovery.button.dismiss": "OK, got it",
  "inline.comments.resolved.discovery.content": "Got more to say? You can reopen resolved comments to continue the discussion.",
  "inline.comments.resolved.menu.show.replies": "{0} replies",
  "inline.comments.resolved.menu.show.reply": "{0} reply",
  "inline.comments.resolved.menu.unresolve": "Reopen",
  "inline.comments.resolved.message": "Resolved by {0} {1}",
  "inline.comments.resolved.view.menu": "Resolved comments",
  "inline.comments.server.edit.error": "We can't save your edit. The comment might have been deleted.",
  "inline.comments.server.error": "Could not complete your request.",
  "inline.comments.server.error.edit.comment": "We can't edit this comment. The comment might have been deleted.",
  "inline.comments.server.error.edit.reply": "We can't edit this reply. The reply might have been deleted.",
  "inline.comments.sidebar.cancel": "Cancel",
  "inline.comments.sidebar.close": "Close",
  "inline.comments.sidebar.comment.empty": "You cannot save an empty comment.",
  "inline.comments.sidebar.delete": "Delete",
  "inline.comments.sidebar.deleted": "Deleted",
  "inline.comments.sidebar.discard": "Discard",
  "inline.comments.sidebar.edit": "Edit",
  "inline.comments.sidebar.error.create.comment": "We can't add your inline comment; the section you highlighted may contain a macro or user mention. Try highlighting plain text.",
  "inline.comments.sidebar.error.delete.generic": "Error deleting comment. Please check the Confluence logs for errors.",
  "inline.comments.sidebar.error.delete.unauthorised": "You do not have sufficient permissions to delete this comment.",
  "inline.comments.sidebar.error.empty": "Please enter your comment.",
  "inline.comments.sidebar.error.save.comment": "Could not save the comment",
  "inline.comments.sidebar.error.save.reply": "Could not save the reply",
  "inline.comments.sidebar.error.stale": "Page content is out of date, please {0}refresh{1} and try again.",
  "inline.comments.sidebar.like": "Like",
  "inline.comments.sidebar.pagecomment.success": "Page comment is created successful",
  "inline.comments.sidebar.reply": "Reply",
  "inline.comments.sidebar.resolve": "Resolve",
  "inline.comments.sidebar.resolved": "Resolved",
  "inline.comments.sidebar.save": "Save",
  "inline.comments.sidebar.saved": "Saved",
  "inline.comments.sidebar.shortcuts.close.description": "Close Inline Comment",
  "inline.comments.sidebar.show.resolved.comment": "Show resolved comments",
  "inline.comments.sidebar.tooltip.close.description": "Close sidebar (])",
  "inline.comments.sidebar.tooltip.next.ic.description": "Next comment (N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "Previous comment (P)",
  "inline.comments.templates.create.a.comment": "<strong>commented</strong> on a page",
  "inline.comments.templates.resolved.a.comment": "<strong>resolved</strong> a comment",
  "inline.comments.templates.resolved.a.comment.dangling": "deleted text referenced by an inline comment, so the comment was <strong>resolved</strong>",
  "inline.comments.templates.unresolved.a.comment": "<strong>re-opened</strong> a comment",
  "inline.comments.unresolved.message": "Reopened by {0} {1}",
  "jar.file": "Java Archive",
  "java.file": "Java Source",
  "jpeg.file": "JPEG File",
  "js.file": "JavaScript File",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl",
  "keyboard.shortcut.option": "Option",
  "keyboard.shortcut.shift": "Shift",
  "label.contains.invalid.chars": "<b>{0}</b> contains invalid characters ({1}).",
  "label.name.is.too.long": "Label names must be less than {0} characters.",
  "labels.dialog.shortcut.tip": "Shortcut tip: In page view, pressing <b>{shortcut}</b> also opens this dialog box",
  "labels.none": "No labels",
  "labels.title": "Labels",
  "last.saved": "Last Saved",
  "likes.bethefirst": "Be the first to like this",
  "likes.follow": "Follow",
  "likes.following": "Following",
  "likes.like": "Like",
  "likes.peoplewholikethis": "People who like this",
  "likes.summary.1.non-promoted": "{0} likes this",
  "likes.summary.1.promoted": "{0} likes this",
  "likes.summary.1.promoted.1.non-promoted": "{0} and {1} like this",
  "likes.summary.1.promoted.x.non-promoted": "{0} and <a href=\"\" {2}>{1} others</a> like this",
  "likes.summary.2.promoted": "{0} and {1} like this",
  "likes.summary.2.promoted.1.non-promoted": "{0}, {1} and {2} like this",
  "likes.summary.2.promoted.x.non-promoted": "{0}, {1} and <a href=\"\" {3}>{2} others</a> like this",
  "likes.summary.3.promoted": "{0}, {1} and {2} like this",
  "likes.summary.3.promoted.1.non-promoted": "{0}, {1}, {2} and {3} like this",
  "likes.summary.3.promoted.x.non-promoted": "{0}, {1}, {2} and <a href=\"\" {4}>{3} others</a> like this",
  "likes.summary.x.non-promoted": "<a href=\"\" {1}>{0} people</a> like this",
  "likes.summary.you": "You like this",
  "likes.summary.you.1.non-promoted": "You and {0} like this",
  "likes.summary.you.1.promoted": "You and {0} like this",
  "likes.summary.you.1.promoted.1.non-promoted": "You, {0} and {1} like this",
  "likes.summary.you.1.promoted.x.non-promoted": "You, {0} and <a href=\"\" {2}>{1} others</a> like this",
  "likes.summary.you.2.promoted": "You, {0} and {1} like this",
  "likes.summary.you.2.promoted.1.non-promoted": "You, {0}, {1} and {2} like this",
  "likes.summary.you.2.promoted.x.non-promoted": "You, {0}, {1} and <a href=\"\" {3}>{2} others</a> like this",
  "likes.summary.you.3.promoted": "You, {0}, {1} and {2} like this",
  "likes.summary.you.3.promoted.1.non-promoted": "You, {0}, {1}, {2} and {3} like this",
  "likes.summary.you.3.promoted.x.non-promoted": "You, {0}, {1}, {2} and <a href=\"\" {4}>{3} others</a> like this",
  "likes.summary.you.x.non-promoted": "You and <a href=\"\" {1}>{0} others</a> like this",
  "likes.unlike": "Unlike",
  "limited.mode.existing.editor.body": "Collaborative editing is offline right now, and {0} is editing this page. Try again in a few minutes.",
  "link.browser.advanced.desc1": "To insert a link to a new page, type in the desired page title.",
  "link.browser.advanced.desc2": "To insert an anchor link, type #anchorname.",
  "link.browser.advanced.error.internal.error": "An internal server error occurred",
  "link.browser.advanced.error.not.link": "The markup provided is not valid link markup",
  "link.browser.advanced.error.unknown.shortcut": "{0} is not a recognised shortcut",
  "link.browser.advanced.error.unknown.space": "{0} is not a recognised space",
  "link.browser.advanced.title": "Here you can insert a link into the page using <a href=\"{0}\" target=\"_blank\">wiki markup</a>.",
  "link.browser.autocomplete.hint": "Hint: type \"[\" in the editor to see a list of suggested pages and insert a link.",
  "link.browser.cancel.button": "Cancel",
  "link.browser.edit.button": "Insert",
  "link.browser.edit.title": "Edit link",
  "link.browser.file.attach": "Upload file",
  "link.browser.file.attach.desc": "Link to a file that is attached to this page or attach a new one.",
  "link.browser.file.attach.upload.in.progress": "Upload in progress…",
  "link.browser.file.browse.button": "Browse",
  "link.browser.files.none": "There are no files on this page.",
  "link.browser.insert.button": "Insert",
  "link.browser.insert.title": "Insert link",
  "link.browser.link": "Link",
  "link.browser.link.alias": "Link text",
  "link.browser.link.image.label": "Link image",
  "link.browser.location": "Link location",
  "link.browser.recently.viewed.load.error": "There was an error loading the recently viewed pages",
  "link.browser.recently.viewed.none": "You have no recently viewed content.",
  "link.browser.search": "Search",
  "link.browser.search.for": "Search for",
  "link.browser.search.invalid": "Invalid search terms",
  "link.browser.search.results.load.error": "There was an error encountered during the search",
  "link.browser.search.results.none": "No search results found.",
  "link.browser.space.all": "All content",
  "link.browser.tab.name.advanced": "Advanced",
  "link.browser.tab.name.files": "Files",
  "link.browser.tab.name.recently.viewed": "Recently viewed",
  "link.browser.tab.name.search": "Search",
  "link.browser.tab.name.weblinks": "Web link",
  "link.browser.table.file.comment": "Comment",
  "link.browser.table.file.name": "Name",
  "link.browser.table.file.size": "Size",
  "link.browser.table.last.modified": "Last modified",
  "link.browser.table.space": "Space",
  "link.browser.table.title": "Title",
  "link.browser.web.link": "URL",
  "link.browser.web.link.desc": "Web, email or any other internet address",
  "link.browser.web.link.label": "Address",
  "location.name": "Location",
  "login.button": "Log in",
  "look.and.feel": "Look and Feel",
  "marketplace.link.name": "Marketplace apps",
  "more.word.action": "More actions",
  "more.word.capitalised": "More",
  "moveblogpost.already.exists.in.target.space": "Another blog post with the same title and date already exists in the selected space.",
  "moveblogpost.source.notfound": "The source blogpost was not found.",
  "moveblogpost.target.space.notfound": "The target space was not found.",
  "moveblogpost.target.space.same.as.origin": "You cannot move a blog post to the space it's already in.",
  "multimedia.file": "Multimedia File",
  "my.drafts.mainBanner": "Capture ideas, quickly",
  "my.drafts.subBanner": "Create a page and get your ideas down. If you're not ready to publish yet, just close the page. We'll autosave it as a draft so you can get back to it when you're ready. ",
  "my.spaces.tooltip.add": "Add to My Spaces",
  "my.spaces.tooltip.remove": "Remove from My Spaces",
  "name.word": "Name",
  "nav.controller.activity": "Activity",
  "nav.controller.activity.feed": "Activity feed",
  "nav.controller.all.spaces": "Spaces",
  "nav.controller.discover": "Discover",
  "nav.controller.my.spaces": "My Spaces",
  "nav.controller.my.spaces.anchor": "All",
  "nav.controller.my.spaces.blank": "Keep your most useful spaces at hand. Hit the star icon beside any space to make it appear here.",
  "nav.controller.my.spaces.blank.callToAction": "Find spaces",
  "nav.controller.projects": "Projects",
  "nav.controller.recent": "Recent pages",
  "nav.controller.your.work": "Your work",
  "navigation.app.switcher.apps": "Apps",
  "navigation.app.switcher.dont.show.again": "Don't show again",
  "navigation.app.switcher.edit": "Edit",
  "navigation.app.switcher.error-message": "Error getting application links.",
  "navigation.app.switcher.home.description": "Home",
  "navigation.app.switcher.img.alt": "Application Switcher",
  "navigation.app.switcher.loading": "Loading...",
  "navigation.app.switcher.recent": "Recent",
  "navigation.app.switcher.recent-containers-confluence-space": "Space",
  "navigation.app.switcher.recent-containers-jira-project": "Project",
  "navigation.app.switcher.try.other.apps": "Try other apps",
  "navigation.app.switcher.use.confluence": "Use Confluence",
  "navigation.app.switcher.use.jira": "Use Jira",
  "navigation.label-for-bell": "Notifications",
  "navigation.label-for-global-people-icon": "People directory",
  "navigation.notification-drawer-title": "Home notifications",
  "navigation.people-drawer-title": "People directory",
  "navlink.edit": "{0}E{1}dit",
  "network.page": "Network Page",
  "no.drafts.found": "No drafts found.",
  "no.matches.mainBanner": "We can't find anything for",
  "no.name": "No",
  "no.permission": "No Permission",
  "no.spaces.found": "No spaces found.",
  "not.watching.anything": "You are not watching anything.",
  "notification.start": "Start Watching",
  "notification.stop": "Stop Watching",
  "notifications.batch.inline.comment.created.section.header": "Inline {0,choice, 1#comment| 1<comments}",
  "notifications.batch.inline.comment.new.lozenge": "new",
  "notifications.batch.inline.comment.new.section.name": "{0,number} new inline {0,choice, 1#comment| 1<comments}",
  "notifications.batch.inline.comment.reopened.lozenge": "reopened",
  "notifications.batch.inline.comment.reopened.section.name": "{0,number} reopened inline {0,choice, 1#comment| 1<comments}",
  "notifications.batch.inline.comment.resolved": "$user $lozenge a comment",
  "notifications.batch.inline.comment.resolved.lozenge": "resolved",
  "notifications.batch.inline.comment.resolved.section.name": "{0,number} resolved inline {0,choice, 1#comment| 1<comments}",
  "notifications.batch.inline.comment.update.section.name": "{0,number} inline comment {0,choice, 1#update| 1<updates}",
  "notifications.preferences.desc": "You can set your email notification options on the <a href=\"viewmyemailsettings.action\">email settings</a> page.",
  "onboarding-choose-a-space.description": "Choose from one of your team's current spaces. You'll be able to create more spaces later on.",
  "onboarding-choose-a-space.title": "Choose a space to work in",
  "onboarding.choose-a-space.backBtn": "Back",
  "onboarding.choose-a-space.nextBtn": "Next",
  "onboarding.choose-a-space.selectLabel": "Space name",
  "onboarding.choose-a-space.selectPlaceholder": "Select the space name",
  "onboarding.create-a-space.backBtn": "Back",
  "onboarding.create-a-space.description": "Start with a space for your current team or project. You'll be able to create more spaces later on.",
  "onboarding.create-a-space.inputTextLabel": "Name",
  "onboarding.create-a-space.inputTextPlaceholder": "Crystal gems",
  "onboarding.create-a-space.invalidMessage": "Space names require at least one letter or number.",
  "onboarding.create-a-space.nextBtn": "Next",
  "onboarding.create-a-space.title": "Create a space to work in",
  "onboarding.dialog.existing-user.cancel": "Don't show tips",
  "onboarding.dialog.existing-user.confirm": "Let's go",
  "onboarding.dialog.existing-user.content": "We've moved a few things around to give you a better dashboard experience, plus turned on some tips to help you get started.",
  "onboarding.dialog.existing-user.title": "Welcome to your new dashboard!",
  "onboarding.dialog.new-user.cancel": "Don't show tips",
  "onboarding.dialog.new-user.confirm": "Let's go",
  "onboarding.dialog.new-user.content": "The dashboard is the landing page that helps you get around Confluence.<br/>We've turned on some tips to get you started",
  "onboarding.dialog.new-user.title": "Welcome to the dashboard!",
  "onboarding.navigation.blog.tip.blog.list.byline": "Hit home to switch to a list of pages or other content.",
  "onboarding.navigation.blog.tip.blog.list.heading": "Your blog list can still be found here",
  "onboarding.navigation.dont.show": "Don't show me more tips",
  "onboarding.navigation.global.sidebar.byline": "So no matter where you are in Confluence, the important things are just one click away.",
  "onboarding.navigation.global.sidebar.heading": "This sidebar is now universal",
  "onboarding.navigation.ok": "OK, got it",
  "onboarding.navigation.page.tip.page.tree.byline": "Hit home to switch to a list of blogs or other content.",
  "onboarding.navigation.page.tip.page.tree.heading": "Your page tree can still be found here",
  "onboarding.navigation.space.tip.space.tabs.byline": "Your space home page is now the overview, and your pages, blog posts, and other content each have their own tab.",
  "onboarding.navigation.space.tip.space.tabs.heading": "Your content is now organised in tabs",
  "onboarding.tooltip.actions.done": "Got it!",
  "onboarding.tooltip.actions.next": "Next",
  "onboarding.tooltip.actions.skip": "Skip tips",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "Jump straight to your favourite spaces or visit the list of all spaces.",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "Favourite spaces at your fingertips",
  "onboarding.tooltip.existing-user.sidebar.content": "Find new pages and get back to your recent work from your slick new sidebar.",
  "onboarding.tooltip.existing-user.sidebar.title": "Discover more with the sidebar",
  "onboarding.tooltip.new-user.favourite-spaces.content": "Jump straight to your favourite spaces or visit the list of all spaces.",
  "onboarding.tooltip.new-user.favourite-spaces.title": "Favourite spaces at your fingertips",
  "onboarding.tooltip.new-user.sidebar.content": "Find new pages and get back to your recent work from the sidebar.",
  "onboarding.tooltip.new-user.sidebar.title": "Discover more with the sidebar",
  "onboarding.tooltip.saved-for-later.content": "Your favourite pages now appear under their new name - Saved for later.",
  "onboarding.tooltip.saved-for-later.title": "Goodbye Favourites, hello Saved for later",
  "onboarding.who-is-on-your-team.addMoreBtn": "+ Add more emails",
  "onboarding.who-is-on-your-team.description": "Confluence is better when teammates create, discuss, and collaborate on work with you.",
  "onboarding.who-is-on-your-team.emailPlaceholder": "Add email address",
  "onboarding.who-is-on-your-team.enableDRS": "Let anyone with a verified {domain} email address join your site (we'll notify you each time this happens).",
  "onboarding.who-is-on-your-team.enableOpenInvite": "Let users invite other people to your site.",
  "onboarding.who-is-on-your-team.form.invalid.email": "Please enter valid email",
  "onboarding.who-is-on-your-team.nextBtn": "Next",
  "onboarding.who-is-on-your-team.title": "Who's on your team?",
  "only.personal.labels.permitted": "You are only permitted to add personal labels on this page.",
  "org.randombits.confluence.toc.toc.label": "Table of Contents",
  "page.already.exists": "Another page with the same title already exists in the selected space.",
  "page.already.exists.inspace": "The page '{0}' already exists in space '{1}'. You need to rename the page title before moving it.",
  "page.change": "What did you change?",
  "page.comments.saved.dialog.message": "Your comment has been saved as a page comment.",
  "page.comments.sidebar.warning": "We can't add an inline comment to this content. We'll add it as a page comment instead.",
  "page.descendent.already.exists": "A descendent page shares the same title of another page in the selected space.",
  "page.permissions.menu.item.title": "Restrictions",
  "page.permissions.menu.item.title.tooltip": "Edit restrictions",
  "page.tree.blankExperience.mainBanner": "There's nothing here but potential.",
  "page.tree.blankExperience.subBanner": "Get creating some meeting notes, product requirements, how-to articles, or other content to see this space fill up.",
  "page.watch.instruction": "To watch a page or blog post: open the &#8216;Tools&#8217; menu and click &#8216;Watch&#8217;.",
  "page.watches": "Page Watches",
  "page.word": "Page",
  "pages.navigation.discovery.body.html": "Click <strong>Pages</strong> to show the page tree and browse pages in this space.",
  "pages.navigation.discovery.header": "The page tree lives here now",
  "pages.show.all": "Show all pages",
  "pages.word": "Pages",
  "pagetree.dragndrop.failed.action.visitsupport": "Visit Atlassian Support",
  "pagetree.dragndrop.failed.description": "Refresh the page and try again. If this keeps happening, let us know using the link below.",
  "pagetree.dragndrop.failed.title": "Something went wrong.",
  "pagetree.failed.load.content": "Page tree failed to load",
  "pagetree.failed.load.tooltip": "Hold tight, we’re working on fixing this.",
  "parent.page.invalid.for.space": "There is no page with the title <b>{0}</b> in space <b>{1}</b>.",
  "parent.page.name": "Parent page",
  "pdf.file": "PDF File",
  "people.directory.name": "People",
  "period.lastSevenDays": "In the last week",
  "period.lastThirtyDays": "In the last month",
  "period.older": "More than a month ago",
  "period.today": "Today",
  "period.yesterday": "Yesterday",
  "permission.owner.not.in.group": "You can only grant page permissions to groups you are a member of",
  "permission.owner.not.set": "You must pick an owner for the permission",
  "permissions.comment": "Define who can view and edit the page. You can restrict these permissions to yourself or a group of users.",
  "permissions.edit.title": "Edit",
  "permissions.select.nopermissions": "Not set",
  "permissions.view.title": "View",
  "person.follow": "Follow",
  "person.follow.stop": "Stop Following",
  "personal.spaces": "Personal Spaces",
  "placeholder.placeholdertext.label": "Placeholder text",
  "placeholder.replacementtext.label": "Replacement text",
  "please.enter.a.label": "Please enter a label.",
  "png.file": "PNG File",
  "popular.stream.mainBanner": "There's not much happening... Yet",
  "popular.stream.subBanner": "Things are pretty quiet right now, but once your team starts creating, the most popular pages and files will appear here.",
  "popular.stream.subBanner2": "Let's get this party started!",
  "popular.stream.title": "Popular",
  "posted.word": "Posted",
  "powerpoint.file": "Microsoft Powerpoint Presentation",
  "powerpoint.macro.file": "Microsoft Powerpoint Macro-Enabled Presentation",
  "powerpoint.slideshow.file": "Microsoft Powerpoint Slideshow",
  "powerpoint.template.file": "Microsoft Powerpoint Template",
  "powerpoint97.file": "Microsoft Powerpoint 97 Slideshow",
  "powerpoint97.template.file": "Microsoft Powerpoint 97 Template",
  "product.name": "Confluence",
  "profile.page": "Profile Page",
  "property.panel.macro.display.inline": "Display inline",
  "property.panel.macro.display.newline": "Display on new line",
  "property.panel.macro.edit": "Edit",
  "property.panel.macro.remove": "Remove",
  "property.panel.textplaceholder.display.default": "Text",
  "property.panel.textplaceholder.display.default.tooltip": "Instructional text is replaced with empty content when a person types.",
  "property.panel.textplaceholder.display.mention": "User mention",
  "property.panel.textplaceholder.display.mention.tooltip": "Instructional text is replaced with suggested people when a person types.",
  "property.panel.textplaceholder.remove": "Remove",
  "property.panel.variable.display.list": "List",
  "property.panel.variable.display.list.tooltip": "Drop down list.",
  "property.panel.variable.display.string": "Text",
  "property.panel.variable.display.string.tooltip": "Single line text input field.",
  "property.panel.variable.display.textarea": "Multi-line Text",
  "property.panel.variable.display.textarea.tooltip": "Multi-line text input field.",
  "property.panel.variable.list.values.tooltip": "Enter each item for the list, separating each with a comma.",
  "property.panel.variable.textarea.columns.tooltip": "Number of columns to display for the field.",
  "property.panel.variable.textarea.rows.tooltip": "Number of rows to display for the field.",
  "quick.comment.placeholder.message": "Write a comment…",
  "quick.reload.edit": "New page edits",
  "quick.reload.edit.by": "by",
  "quick.reload.edit.more": "and {0} others",
  "quick.reload.edit.one.more": "and 1 other",
  "quick.reload.edits": "{0} new edits",
  "quick.reload.newcomments": "{0} new comments",
  "quick.reload.newpagecomment": "New comment",
  "quick.reload.reload": "Reload page",
  "recently-updated-content-list.commented.new": "Commented {time}",
  "recently-updated-content-list.created.new": "Created {time}",
  "recently-updated-content-list.edited.new": "Updated {time}",
  "recently.viewed.mainBanner": "Time to make history",
  "recently.viewed.subBanner": "You haven't visited any pages yet, but when you do, we'll drop them here so you can get back to them fast.",
  "recently.viewed.subBanner2": "Head over to a <b>space</b> now and have a look around.",
  "recently.viewed.title": "Recently visited",
  "recently.worked.mainBanner": "Finish that masterpiece",
  "recently.worked.subBanner": "You haven't created or edited anything yet, but when you do, we'll drop it here so it's easy to pick up where you left off.",
  "recently.worked.subBanner2": "Now, go and create your greatest work.",
  "recently.worked.title": "Recently worked on",
  "remove.comment.confirmation.message": "Are you sure you want to delete the comment?",
  "remove.label": "Delete Label",
  "resize.image.dialog.title": "Resize image",
  "restore.this.version": "Restore this version",
  "result.grid.column.content.last.modified": "Last modified",
  "resume.editing": "Resume",
  "return.to.page.info": "Return to Page Information",
  "satisfaction.survey.reaction.amazing": "Amazing",
  "satisfaction.survey.reaction.bad": "Bad",
  "satisfaction.survey.reaction.great": "Great",
  "satisfaction.survey.reaction.okay": "Okay",
  "satisfaction.survey.reaction.terrible": "Terrible",
  "save.name": "Save",
  "scheme.desc.custom": "A custom colour scheme which can be edited.",
  "scheme.desc.global": "This colour scheme will use the globally defined colour scheme for this space.",
  "scheme.title.custom": "Custom Colour Scheme",
  "scheme.title.global": "Global Colour Scheme",
  "search.drawer.recently.viewed": "Recently viewed",
  "search.drawer.recently.viewed.spaces": "Recent spaces",
  "search.name": "Search",
  "settings.name": "Settings",
  "share.button.restriction.message.text": "Restrictions on this page may prevent people from viewing or editing",
  "share.button.text": "Share",
  "show.more.blogposts": "Show more blog posts",
  "sidebar.avatar.picker.upload.error": "An error occurred while updating space details",
  "sidebar.main.back.to.overview": "Back to Overview",
  "sidebar.main.back.to.space": "Back to space",
  "sidebar.main.blog": "Blog",
  "sidebar.main.quick.links": "Space shortcuts",
  "sidebar.main.settings": "Space settings",
  "sidebar.main.shortcuts": "Links",
  "sidebar.main.wiki": "Pages",
  "site-settings.templates-and-blueprints.edit-button-label": "Edit",
  "space.404.banner.title": "Oops, you've found a dead link",
  "space.404.go.back": "Go back to the",
  "space.404.go.to": "Go to the",
  "space.404.home.page": "home page",
  "space.404.previous.page": "previous page",
  "space.create": "Create Space",
  "space.home.blog.blankExperience.mainBanner": "Got something to share?",
  "space.home.blog.blankExperience.subBanner": "Blog posts are a great way to share announcements, status reports or other important news with your team.",
  "space.home.overview.blankExperience.mainBanner": "Well, this is a bit awkward.",
  "space.home.overview.blankExperience.subBanner": "This space doesn't have a homepage so there's nothing to display here. Sad panda.",
  "space.home.overview.blankExperience.subBanner2": "Add a homepage now to spruce things up, and use it to tell your visitors what this space is all about!",
  "space.not.exists": "The space you have specified does not exist.",
  "space.personal.name": "Personal Space",
  "space.set.space.home": "Set space home",
  "space.watch.instruction": "To watch pages or blog posts in spaces click on &#8216;Pages&#8217; or &#8216;Blog&#8217; in the space sidebar.",
  "space.watches": "Space Watches",
  "spaces.all": "All spaces",
  "spaces.lookandfeel.help": "Here you can customise the look of this Confluence space.",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">Note:</span> <i>Any modifications done here will override the default colour-scheme and default decorators, set up by your administrator.</i>",
  "spaces.word": "Spaces",
  "starred.mainBanner": "Nothing to see here... Yet",
  "starred.spaces.tooltip.add": "Star this space",
  "starred.spaces.tooltip.remove": "Unstar this space",
  "starred.subBanner": "Hit the <b>star icon</b> to save a page for later. We'll drop it here so you can find it when you need it.",
  "starred.title": "Saved for later",
  "status.lozenge.draft": "Draft",
  "status.lozenge.unpublished": "Unpublished changes",
  "submit.name": "Submit",
  "super-admin.banner.exit": "Stop using admin key",
  "super-admin.banner.message": "You’re using admin key, which gives you temporary access to restricted content.",
  "switch.apps": "Switch apps",
  "system.help.legal": "Legal",
  "team.create.flag.error.description": "We weren't able to create a team for you. Try again soon.",
  "team.create.flag.error.title": "Oops! Something went wrong.",
  "team.created.flag.description": "You invited {membersCount} {membersCount, plural, one {person} other {people}} to the team '{teamName}'",
  "team.created.flag.title": "New team created",
  "team.created.flag.view": "View team",
  "template.variables.fabric.section.message": "This template uses variables. Once you fill them in, the information you supply will become part of the content in your new page.",
  "templates.name": "Templates",
  "text.file": "Text File",
  "text.selected": "Selected",
  "tinymce.advanced.block": "Format",
  "tinymce.advanced.blockquote": "Quote",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "Bold",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "Bullet list",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Shift+B",
  "tinymce.advanced.charmap_desc": "Symbol",
  "tinymce.advanced.forecolor_desc": "Select text colour",
  "tinymce.advanced.formatting_desc": "Formatting",
  "tinymce.advanced.h1": "Heading 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "Heading 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "Heading 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "Heading 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "Heading 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "Heading 6",
  "tinymce.advanced.h6_shortcut": "Ctrl+6",
  "tinymce.advanced.headings": "Headings 1 to 6",
  "tinymce.advanced.headings_shortcut": "Ctrl+1..6",
  "tinymce.advanced.hr_desc": "Horizontal rule",
  "tinymce.advanced.indent_desc": "Indent",
  "tinymce.advanced.italic_desc": "Italic",
  "tinymce.advanced.italic_shortcut": "Ctrl+I",
  "tinymce.advanced.justifycenter_desc": "Align center",
  "tinymce.advanced.justifyfull_desc": "Align full",
  "tinymce.advanced.justifyleft_desc": "Align left",
  "tinymce.advanced.justifyright_desc": "Align right",
  "tinymce.advanced.numlist_desc": "Numbered list",
  "tinymce.advanced.numlist_shortcut": "Ctrl+Shift+N",
  "tinymce.advanced.outdent_desc": "Outdent",
  "tinymce.advanced.paragraph": "Paragraph",
  "tinymce.advanced.paragraph_shortcut": "Ctrl+0",
  "tinymce.advanced.pre": "Preformatted",
  "tinymce.advanced.pre_shortcut": "Ctrl+7",
  "tinymce.advanced.redo_desc": "Redo",
  "tinymce.advanced.redo_shortcut": "Ctrl+Y",
  "tinymce.advanced.striketrough_desc": "Strikethrough",
  "tinymce.advanced.striketrough_shortcut": "Ctrl+Shift+S",
  "tinymce.advanced.sub_desc": "Subscript",
  "tinymce.advanced.sup_desc": "Superscript",
  "tinymce.advanced.tasklist_desc": "Task list",
  "tinymce.advanced.tasklist_shortcut": "[ then ]",
  "tinymce.advanced.underline_desc": "Underline",
  "tinymce.advanced.underline_shortcut": "Ctrl+U",
  "tinymce.advanced.undo_desc": "Undo",
  "tinymce.advanced.undo_shortcut": "Ctrl+Z",
  "tinymce.advanced.unlink_desc": "Unlink",
  "tinymce.atlassian.help": "Help",
  "tinymce.atlassian.insert_menu": "Insert",
  "tinymce.atlassian.insert_menu.charmap_desc": "Insert symbol",
  "tinymce.atlassian.insert_menu.content_desc": "Insert content",
  "tinymce.atlassian.insert_menu.hr_desc": "Insert horizontal rule (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "Insert macro",
  "tinymce.atlassian.insert_menu.tooltip": "Insert more content",
  "tinymce.atlassian.monospace": "Monospace",
  "tinymce.atlassian.monospace_desc": "Format text with monospaced font",
  "tinymce.atlassian.more_menu": "More",
  "tinymce.atlassian.remove_formatting": "Clear formatting",
  "tinymce.atlassian.remove_formatting_desc": "Clears formatting on currently selected text",
  "tinymce.auiwindowmanager.cancel": "Cancel",
  "tinymce.auiwindowmanager.ok": "OK",
  "tinymce.autocomplete.web.resource.name": "Confluence autocomplete web resources",
  "tinymce.autocomplete.web.resource.only.name": "Confluence autocomplete web resources without dependencies",
  "tinymce.charmap.web.resource.name": "TinyMce character map web resources",
  "tinymce.charmap_dlg.title": "Insert symbol",
  "tinymce.colorpicker.color": "Colour",
  "tinymce.colorpicker.more_colors": "More colours",
  "tinymce.colorpicker.picker_tab": "Picker",
  "tinymce.colorpicker.picker_title": "Colour picker",
  "tinymce.colorpicker.title": "Select a colour",
  "tinymce.colorpicker.web.resource.name": "Confluence colour picker web resources",
  "tinymce.confluence.conf_emoji": "Emoji",
  "tinymce.confluence.conf_emoticon": "Emoticon",
  "tinymce.confluence.conf_emoticon_desc": "Insert Emoticon",
  "tinymce.confluence.conf_file": "Files and images",
  "tinymce.confluence.conf_file_desc": "Insert files and images",
  "tinymce.confluence.conf_file_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_image": "Image",
  "tinymce.confluence.conf_image_desc": "Insert image",
  "tinymce.confluence.conf_image_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_link": "Link",
  "tinymce.confluence.conf_link_desc": "Insert link",
  "tinymce.confluence.conf_link_shortcut": "Ctrl+K",
  "tinymce.confluence.conf_macro_browser": "Macro",
  "tinymce.confluence.conf_macro_browser_desc": "Insert macro",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl+Shift+A",
  "tinymce.confluence.conf_media": "Image/Media",
  "tinymce.confluence.conf_other_macros_desc": "Other macros...",
  "tinymce.confluence.conf_shortcuts_help": "Keyboard shortcuts help",
  "tinymce.confluence.conf_tasklist": "Task list",
  "tinymce.confluence.conf_tasklist_desc": "Insert task list",
  "tinymce.confluence.conf_tasklist_shortcut": "[ then ]",
  "tinymce.confluence.conf_widget_desc": "Widget",
  "tinymce.confluence.conf_wikimarkup": "Markup",
  "tinymce.confluence.conf_wikimarkup.insert.label": "Insert",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "Confluence wiki",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "Wiki markup conversion errors",
  "tinymce.confluence.conf_wikimarkup_desc": "Insert markup",
  "tinymce.confluence.conf_wikimarkup_hint": "Hint: you can also enter wiki markup directly in the editor, where it will be formatted as you type.",
  "tinymce.confluence.conf_wikimarkup_info_title": " Enter wiki markup or markdown below. Confluence will convert your content to editor format and insert it into your page.",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "Markdown",
  "tinymce.confluence.conf_wikimarkup_preview_label": "Preview",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl+Shift+D",
  "tinymce.confluence.conf_wikimarkup_timeout": "The server took too long to convert the wiki markup. This may only be a temporary problem so you could try again.",
  "tinymce.confluence.files": "Files",
  "tinymce.confluence.help_desc": "Help",
  "tinymce.confluence.htmlsource": "Source",
  "tinymce.confluence.htmlsource_desc": "View HTML source",
  "tinymce.confluence.layout.menu": "Page layout",
  "tinymce.confluence.layout.none": "No layout",
  "tinymce.confluence.layout.three_col": "Three column",
  "tinymce.confluence.layout.three_col_sidebars": "Three column (left and right sidebars)",
  "tinymce.confluence.layout.three_col_simple": "Three column (simple)",
  "tinymce.confluence.layout.two_col": "Two column",
  "tinymce.confluence.layout.two_col_left": "Two column (left sidebar)",
  "tinymce.confluence.layout.two_col_right": "Two column (right sidebar)",
  "tinymce.confluence.layout.two_col_simple": "Two column (simple)",
  "tinymce.confluence.layout.two_col_simple_left": "Two column (simple, left sidebar)",
  "tinymce.confluence.layout.two_col_simple_right": "Two column (simple, right sidebar)",
  "tinymce.confluence.macro_insert": "Insert '{0}' macro",
  "tinymce.confluence.macro_other": "Other macros",
  "tinymce.confluence.macro_other_desc": "Open the macro browser",
  "tinymce.confluence.placeholder.inline.tasks": "Type your task here, using \"@\" to assign to a user and \"//\" to select a due date",
  "tinymce.confluence.preview": "Preview",
  "tinymce.confluence.preview_shortcut": "Ctrl+Shift+E",
  "tinymce.confluence.save_shortcut": "Ctrl+S",
  "tinymce.confluence.settings_desc": "Editor settings",
  "tinymce.confluence_dlg.insertbutton.title": "Insert",
  "tinymce.confluence_dlg.insertimage.title": "Insert image",
  "tinymce.confluence_dlg.insertlink.title": "Insert link",
  "tinymce.emotions.emotions_desc": "Emoticons",
  "tinymce.emotions.web.resource.name": "TinyMce emotions web resources",
  "tinymce.emotions_dlg.add": "Plus (+)",
  "tinymce.emotions_dlg.biggrin": "Big grin :D",
  "tinymce.emotions_dlg.broken_heart": "Broken heart </3",
  "tinymce.emotions_dlg.check": "Tick (/)",
  "tinymce.emotions_dlg.desc": "Emoticons",
  "tinymce.emotions_dlg.error": "Error (x)",
  "tinymce.emotions_dlg.forbidden": "Minus (-)",
  "tinymce.emotions_dlg.heart": "Heart <3",
  "tinymce.emotions_dlg.help_16": "Question mark (?)",
  "tinymce.emotions_dlg.information": "Info (i)",
  "tinymce.emotions_dlg.lightbulb": "Lightbulb off (off)",
  "tinymce.emotions_dlg.lightbulb_on": "Lightbulb on (on)",
  "tinymce.emotions_dlg.sad": "Sad :(",
  "tinymce.emotions_dlg.smile": "Smile :)",
  "tinymce.emotions_dlg.star_blue": "Blue star (*b)",
  "tinymce.emotions_dlg.star_green": "Green star (*g)",
  "tinymce.emotions_dlg.star_red": "Red star (*r)",
  "tinymce.emotions_dlg.star_yellow": "Yellow star (*y)",
  "tinymce.emotions_dlg.thumbs_down": "Thumbs down (n)",
  "tinymce.emotions_dlg.thumbs_up": "Thumbs up (y)",
  "tinymce.emotions_dlg.title": "Insert Emoticon",
  "tinymce.emotions_dlg.tongue": "Tongue :p",
  "tinymce.emotions_dlg.warning": "Warning (!)",
  "tinymce.emotions_dlg.wink": "Wink ;)",
  "tinymce.fabric.migration.dialog.action": "Continue editing",
  "tinymce.fabric.migration.dialog.content": "Don't worry, your changes aren't lost. We just needed to update your page.",
  "tinymce.fabric.migration.dialog.title": "We've just updated your editing experience",
  "tinymce.formatting.paragraph": "Normal Text",
  "tinymce.full_screen.toolbar_item": "Full screen",
  "tinymce.full_screen.toolbar_item_title": "Launch editor full screen",
  "tinymce.hints.autoformat.code": "Hint: Type \"<strong>'{{'code'}}'</strong>\" to quickly insert monospaced text.",
  "tinymce.hints.autoformat.heading1": "Hint: Type \"<strong>h1. Title</strong>\" to quickly insert a Heading 1.",
  "tinymce.hints.autoformat.heading3": "Hint: Type \"<strong>h3. Title</strong>\" to quickly insert a Heading 3.",
  "tinymce.hints.dnd": "Hint: you can drag and drop images and Office files from your computer right into this editor.",
  "tinymce.hints.drafts": "Hint: Confluence saves drafts automatically. If you ever lose a window, recover your work from the \"Username -> Drafts\" menu.",
  "tinymce.hints.insert.bullet.list": "Hint: press <strong>Ctrl+Shift+B</strong> to start a bullet list.",
  "tinymce.hints.insert.heading": "Hint: press <strong>Ctrl+1</strong> to create a heading level 1, <strong>Ctrl+2</strong> for heading level 2 and so on.",
  "tinymce.hints.insert.image": "Hint: press <strong>Ctrl+M</strong> to open the image browser.",
  "tinymce.hints.insert.image.end": "Hint: press <strong>Ctrl+Shift+M</strong> after a word to find and insert relevant images.",
  "tinymce.hints.insert.image.on.page": "Hint: type \"<strong>!</strong>\" to see images attached to the page and insert one of them.",
  "tinymce.hints.insert.image.search": "Hint: type \"<strong>!</strong>\" and part of an image name to find and insert the image.",
  "tinymce.hints.insert.link": "Hint: press <strong>Ctrl+K</strong> to open the link browser.",
  "tinymce.hints.insert.link.end": "Hint: press <strong>Ctrl+Shift+K</strong> after a word to find and link to relevant pages. Press it again for more suggestions.",
  "tinymce.hints.insert.link.newpage": "Hint: type \"<strong>[</strong>\" and the title of a new page you wish to create, to see an insert link suggestion.",
  "tinymce.hints.insert.link.recently.viewed": "Hint: type \"<strong>[</strong>\" to see a list of suggested pages and insert a link.",
  "tinymce.hints.insert.link.search": "Hint: type \"<strong>[</strong>\" and part of a page title to find and link to that page.",
  "tinymce.hints.insert.link.user.mention": "Hint: you can mention somebody in Confluence by typing \"<strong>@</strong>\" and then their name.",
  "tinymce.hints.insert.macro": "Hint: press <strong>Ctrl+Shift+A</strong> to open the macro browser.",
  "tinymce.hints.insert.macro.toc": "Hint: Let Confluence generate you a table of contents for this page. Use \"Insert -> Table of contents\"",
  "tinymce.hints.insert.newline": "Hint: Type <strong>Shift+Enter</strong> to insert a new paragraph without spacing",
  "tinymce.hints.insert.numbered.list": "Hint: press <strong>Ctrl+Shift+N</strong> to start a numbered list.",
  "tinymce.hints.insert.table": "Hint: press <strong>Ctrl+Shift+I</strong> to insert a table.",
  "tinymce.hints.insert.wikimarkup": "Hint: the Editor will automatically convert wiki markup as you type it.",
  "tinymce.hints.insert.wikimarkup.dialog": "Hint: press <strong>Ctrl+Shift+D</strong> to open the Wiki Markup dialog.",
  "tinymce.hints.table.rows.copy": "Hint: press <strong>Ctrl+Shift+C</strong> to copy a row and <strong>Ctrl+Shift+V</strong> to paste a row in a table.",
  "tinymce.hints.table.rows.cut": "Hint: press <strong>Ctrl+Shift+X</strong> to cut a row and <strong>Ctrl+Shift+V</strong> to paste a row in a table.",
  "tinymce.macro.preview.exception": "An exception occurred while previewing the macro. Exception: {0}",
  "tinymce.macro.unknownMacro": "The macro '{0}' is unknown. It may have been removed from the system.",
  "tinymce.popup_blocked": "The browser has blocked a popup opened by the Editor.",
  "tinymce.propertypanel.images.border": "Border",
  "tinymce.propertypanel.images.border.tooltip": "Display a border around image",
  "tinymce.propertypanel.images.large": "Large",
  "tinymce.propertypanel.images.large.tooltip": "Resize image to large and link to the original",
  "tinymce.propertypanel.images.link.create": "Link",
  "tinymce.propertypanel.images.link.create.tooltip": "Link this image to other content",
  "tinymce.propertypanel.images.link.edit": "Edit link",
  "tinymce.propertypanel.images.link.edit.tooltip": "Edit the link for this image",
  "tinymce.propertypanel.images.link.remove": "Unlink",
  "tinymce.propertypanel.images.link.remove.tooltip": "Remove the link for this image",
  "tinymce.propertypanel.images.medium": "Medium",
  "tinymce.propertypanel.images.medium.tooltip": "Resize image to medium and link to the original",
  "tinymce.propertypanel.images.original": "Original",
  "tinymce.propertypanel.images.original.tooltip": "Reset image size to original",
  "tinymce.propertypanel.images.sizing.tooltip": "Resize image to a specific width",
  "tinymce.propertypanel.images.small": "Small",
  "tinymce.propertypanel.images.small.tooltip": "Resize image to small and link to the original",
  "tinymce.propertypanel.links.edit": "Edit",
  "tinymce.propertypanel.links.edit.tooltip": "Edit link in a dialogue",
  "tinymce.propertypanel.links.goto": "Go to link",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "This link goes to content on the page you are editing",
  "tinymce.propertypanel.links.unlink": "Unlink",
  "tinymce.propertypanel.links.unlink.tooltip": "Replace link with the text it contains",
  "tinymce.searchreplace.replace_desc": "Find/Replace",
  "tinymce.searchreplace.search_desc": "Find",
  "tinymce.searchreplace_dlg.allreplaced.plural": "{0} replacements were made",
  "tinymce.searchreplace_dlg.allreplaced.singular": "1 replacement was made",
  "tinymce.searchreplace_dlg.close": "Close",
  "tinymce.searchreplace_dlg.direction": "Direction",
  "tinymce.searchreplace_dlg.down": "Down",
  "tinymce.searchreplace_dlg.findlabel": "Find",
  "tinymce.searchreplace_dlg.findnext": "Next",
  "tinymce.searchreplace_dlg.findprevious": "Previous",
  "tinymce.searchreplace_dlg.findwhat": "Find what",
  "tinymce.searchreplace_dlg.mcase": "Match case",
  "tinymce.searchreplace_dlg.notfound": "No replacements were made",
  "tinymce.searchreplace_dlg.replace": "Replace",
  "tinymce.searchreplace_dlg.replace_title": "Find/Replace",
  "tinymce.searchreplace_dlg.replaceall": "Replace all",
  "tinymce.searchreplace_dlg.replacelabel": "Replace",
  "tinymce.searchreplace_dlg.search_title": "Find",
  "tinymce.searchreplace_dlg.searchnext_desc": "Find again",
  "tinymce.searchreplace_dlg.up": "Up",
  "tinymce.style.show-eol-markers": "¶",
  "tinymce.style.show-eol-markers.title": "Show/hide end of line markers",
  "tinymce.table": "Table",
  "tinymce.table.cell": "Cell",
  "tinymce.table.col": "Column",
  "tinymce.table.col_after_desc": "Insert column after",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+Option+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Shift+→",
  "tinymce.table.col_before_desc": "Insert column before",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+Option+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Shift+←",
  "tinymce.table.col_copy_desc": "Copy table column",
  "tinymce.table.col_cut_desc": "Cut table column",
  "tinymce.table.col_highlight": "Heading column",
  "tinymce.table.col_paste_desc": "Paste table column",
  "tinymce.table.copy_row_desc": "Copy table row",
  "tinymce.table.copy_row_shortcut": "Ctrl+Shift+C",
  "tinymce.table.cut_row_desc": "Cut table row",
  "tinymce.table.cut_row_shortcut": "Ctrl+Shift+X",
  "tinymce.table.del": "Remove table",
  "tinymce.table.delete_col_desc": "Remove column",
  "tinymce.table.delete_row_desc": "Remove row",
  "tinymce.table.desc": "Insert table",
  "tinymce.table.fixed_width": "Fixed width",
  "tinymce.table.fixed_width_tooltip": "Drag column borders to set width. The table always appears at the width you set.",
  "tinymce.table.highlight_colour": "Highlight colour",
  "tinymce.table.merge_cells_desc": "Merge table cells",
  "tinymce.table.more.heading": "Table settings",
  "tinymce.table.numbering_column_desc": "Insert numbering column",
  "tinymce.table.paste_row_after_desc": "Paste row after",
  "tinymce.table.paste_row_before_desc": "Paste table row",
  "tinymce.table.paste_row_before_shortcut": "Ctrl+Shift+V",
  "tinymce.table.responsive": "Responsive",
  "tinymce.table.responsive_tooltip": "Table columns get wider as you add content. Drag column borders to set width relative to each other and the page.",
  "tinymce.table.row": "Row",
  "tinymce.table.row_after_desc": "Insert row after",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+Option+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Shift+↓",
  "tinymce.table.row_after_shortcut": "Alt+↓",
  "tinymce.table.row_before_desc": "Insert row before",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+Option+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Shift+↑",
  "tinymce.table.row_before_shortcut": "Alt+↑",
  "tinymce.table.row_highlight": "Heading row",
  "tinymce.table.selection_highlight": "Change cell colour",
  "tinymce.table.split_cells_desc": "Split merged table cells",
  "tinymce.table_dlg.cols": "Columns",
  "tinymce.table_dlg.equal.width.columns": "Equal width columns",
  "tinymce.table_dlg.fullwidth": "Full width",
  "tinymce.table_dlg.heading": "First row is heading",
  "tinymce.table_dlg.invalid_table_field": "Rows and columns must both be numbers greater than zero.",
  "tinymce.table_dlg.rows": "Rows",
  "tinymce.table_dlg.sizetofit": "Size to content",
  "tinymce.table_dlg.title": "Insert table",
  "tinymce.table_dlg.width": "Width",
  "tinymce.table_shortcut": "Ctrl+Shift+I",
  "tinymce.tablepicker.insert_table": "Table",
  "tinymce.tablepicker.insert_table_title": "Insert table",
  "tinymce.tablepicker.nested_table_unsupported": "Nested tables are unsupported",
  "tinymce.tablepicker.pickerbox.tooltip": "Hold SHIFT for a table without a heading.",
  "tinymce.templates.actions.defined": "Items to insert into this page.",
  "tinymce.templates.insert-template": "Template",
  "tinymce.templates.insert-template.tooltip": "Insert template items into this page.",
  "tinymce.templates.placeholder": "Instructional text",
  "tinymce.templates.placeholder.add": "Placeholder",
  "tinymce.templates.placeholder.add.tooltip": "Insert a text placeholder into the page.",
  "tinymce.templates.placeholder.tooltip": "Disappears when a user types, not shown when viewing a page.",
  "tinymce.templates.variables.add": "New variable",
  "tinymce.templates.variables.add.tooltip": "Add a new field into the page for the template user to fill out.",
  "tinymce.templates.variables.defined": "Variables to insert into this page.",
  "tinymce.templates.variables.insert.tooltip": "Insert the '{0}' field into the page for the template user to fill out.",
  "tinymce.templates.variables.manage": "Manage variables",
  "tinymce.templates.variables.none": "No variables defined",
  "tinymce.templates.variables.none.tooltip": "No variables have been created.",
  "tinymce.tools.toolbar_item_hide": "Hide tools",
  "tinymce.tools.toolbar_item_hide_title": "Hide the toolbars",
  "tinymce.tools.toolbar_item_show": "Show tools",
  "tinymce.tools.toolbar_item_show_title": "Show the toolbars",
  "tinymce.web.css.resource.name": "Confluence editor CSS web resources",
  "tinymce.web.js.resource.name": "Confluence editor Javascript web resources",
  "tinymce.web.resource.name": "Confluence editor web resources",
  "title.add.blogpost": "Add Blog Post",
  "title.add.page": "Add Page",
  "title.add.page.template": "Create template",
  "title.comment": "Comment",
  "title.dashboard": "Dashboard",
  "title.edit.page.template": "Edit template",
  "title.manage.groups": "Groups",
  "title.name": "Title",
  "type.allcontent": "All content",
  "unknown.file": "File",
  "unsaved.comment.lost": "Your comment will be lost.",
  "unsaved.content.lost": "Changes that you made may not be saved.",
  "unsaved.template.lost": "Your unsaved template changes will be lost.",
  "untitled.draft.title": "Untitled",
  "upm.marketplace.section": "Atlassian Marketplace",
  "usermanagement.label": "User management",
  "usermanagement.parent.label": "Site administration",
  "users.name": "Users",
  "view-changes-dialog.close.dialog": "Close",
  "view-changes-dialog.editor.quit-dialog.title.diff": "Unpublished changes",
  "view.change": "view change",
  "view.profile": "View Profile",
  "viewdrafts.page.desc": "When you edit a page but don't publish the changes, a draft is created. Hit <b>Resume</b> to continue editing or publish the changes.",
  "welcome.message.edit": "Share useful links, announcements and info here",
  "welcome.message.edit.link": "Customise",
  "word.file": "Microsoft Word Document",
  "word.template.file": "Microsoft Word Template",
  "word97.file": "Microsoft Word 97 Document",
  "word97.template.file": "Microsoft Word 97 Template",
  "xml.file": "XML File",
  "yes.name": "Yes",
  "your.profile.and.settings": "Your profile and settings",
  "zip.file": "ZIP Archive"
}